module.exports = __webpack_public_path__ + "static/cover.43dfdd4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover.jpg
// module id = 440
// module chunks = 168707334958949